import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "34",
  height: "42",
  viewBox: "0 0 34 42",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  role: "presentation"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M18.1533 40.6167L18.0957 40.6594C17.6688 40.9759 17.1569 41.0389 16.7436 40.98C16.332 40.9213 15.8594 40.7189 15.5386 40.298C15.5376 40.2967 15.5366 40.2954 15.5356 40.2941L4.20889 25.5901C4.20861 25.5897 4.20832 25.5893 4.20804 25.589C2.16477 22.9458 1 19.7582 1 16.3818C1 7.8544 8.23894 1 17 1C25.7611 1 33 7.8544 33 16.3818C33 19.758 31.8353 22.9456 29.7922 25.5886L18.1533 40.6167ZM18.1533 40.6167L18.2042 40.5661L18.3714 40.4003L18.4187 40.3534L18.4594 40.3006L29.7911 25.5901L18.1533 40.6167Z",
  fill: "#428542",
  stroke: "white",
  "stroke-width": "2"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }